import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import Calendar from 'react-calendar'
import { translate } from 'react-i18next'
import TextField from '../TextField'

import './DateMonthYearInput.css'

const DateMonthYearInput = ({ t, label, onChange, required, placeholder }) => {
  const [date, setDate] = useState('')
  const [calendarView, setCalendarView] = useState(false)
  const [startDateView, setStartDateView] = useState(new Date())
  const ref = useRef(null)

  const closeCalendarView = () => setCalendarView(false)
  const toggleCalendarView = () => setCalendarView(!calendarView)

  const convertDateToMoment = (date) => moment(date)

  const handleDateChange = (selectedDate) => {
    const selectedDateConverted = convertDateToMoment(selectedDate) || null
    closeCalendarView()
    setStartDateView(selectedDate)
    setDate(formatDateToMonthYear(selectedDateConverted))
    returnDateInOnChange(selectedDateConverted)
  }

  const returnDateInOnChange = (selectedDate) => {
    const dateYearMonth = formatDateToReturnInOnChange(selectedDate)
    onChange && onChange(dateYearMonth)
  }

  const formatDateToReturnInOnChange = (selectedDate) => {
    const month = String(selectedDate.month() + 1)
    const year = selectedDate.year()
    const dateYearMonth = `${year}${month.padStart(2, '0')}`

    return dateYearMonth
  }

  const formatDateToMonthYear = (dateInMomentFormat) =>
    dateInMomentFormat.format('MMMM/YYYY')

  const setMaxDateToSelectInCalendar = () =>
    new Date(moment().year(), 12, 1, 0, 0, 0, 0)

  useEffect(() => {
    window.addEventListener('resize', () => closeCalendarView())
    document.addEventListener('scroll', () => closeCalendarView(), true)

    return () => {
      window.removeEventListener('resize', () => closeCalendarView())
      document.removeEventListener('scroll', () => closeCalendarView(), true)
    }
  }, [])

  const getHtmlValues = (element) => {
    let currentElement = element
    let top = element.offsetTop
    let left = element.offsetLeft
    const windowHeight = window.innerHeight

    while (currentElement.offsetParent) {
      currentElement = currentElement.offsetParent
      top += currentElement.offsetTop
      left += currentElement.offsetLeft
    }

    if (currentElement.className === 'filters fixed open')
      left -= currentElement.offsetLeft

    currentElement = element
    let scrollTop = 0

    while (currentElement.parentElement) {
      if (window.getComputedStyle(currentElement).position === 'fixed') break
      scrollTop += currentElement.scrollTop
      currentElement = currentElement.parentElement
    }
    scrollTop += currentElement.scrollTop

    const calculatedTopValue = top - (scrollTop + 10) + element.clientHeight
    const renderAbove = calculatedTopValue + 282 >= windowHeight

    const finalTopValue = renderAbove
      ? top - (scrollTop + 194)
      : calculatedTopValue

    return [finalTopValue, left]
  }

  const [top, left] = (ref.current && getHtmlValues(ref.current)) || [0, 0]

  return (
    <div
      className={`date-month-input-wrapper ${
        calendarView ? 'calendar-open' : ''
      }`}
      ref={ref}
    >
      <TextField
        type='text'
        label={label}
        placeholder={placeholder}
        successText={t('dateintervalinput.valid')}
        errorText={t('dateintervalinput.invalid')}
        warningText={t('dateintervalinput.required')}
        required={required}
        rightIcon='glyph glyph-calendar'
        onRightIconClick={toggleCalendarView}
        onClick={toggleCalendarView}
        validateValue={(currentDateMonth) => {
          Boolean(convertDateToMoment(currentDateMonth)) &&
            Boolean(currentDateMonth)
        }}
        isControlledValue
        controlledValue={date}
        fill
      />
      {calendarView && (
        <div className='daterange-title date-month-input'>
          <div className='rangepicker' style={{ top, left }}>
            <Calendar
              defaultView='month'
              maxDetail='year'
              minDetail='month'
              calendarType='US'
              onChange={handleDateChange}
              className='react-calendar'
              maxDate={setMaxDateToSelectInCalendar()}
              defaultActiveStartDate={startDateView}
            />
          </div>
        </div>
      )}
    </div>
  )
}

DateMonthYearInput.propTypes = {
  t: PropTypes.func,
  label: PropTypes.string,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  placeholder: PropTypes.string,
}

export default translate(null, { wait: true, translateFuncName: 't' })(
  DateMonthYearInput
)
